import { UpdateThreadBubbleStatus, UpdateThreadBubbleStatusVariables } from "_graphql/mutation/__generated__/UpdateThreadBubbleStatus"

import { BrokerReadTransactionThread } from "_graphql/mutation/__generated__/BrokerReadTransactionThread"
import { BrokerReadTransactionThreadVariables } from "_graphql/mutation/__generated__/BrokerReadTransactionThread"
import { brokerReadTransactionThread } from "_graphql/visal/mutations/offers"
import { placeItClient } from "_graphql"
import { updateThreadBubbleStatus } from "_graphql/place-it/mutations/underwriter.place-it"
import { useMutation } from "@apollo/client"

export const useUpdateBubble = (variables?: UpdateThreadBubbleStatusVariables) => {
    const [updateBubble, { ...rest }] = useMutation<UpdateThreadBubbleStatus, UpdateThreadBubbleStatusVariables>(updateThreadBubbleStatus, {
        client: placeItClient,
        refetchQueries: ["BrokerOffers", "Offers", "ReinsurerOffers", "UnderwriterOffers"],
    })
    return {
        updateBubble,
        ...rest
    }
}


export const useUpdateKavaThreadBuble = (variables?: BrokerReadTransactionThreadVariables) => {
    const [updateBubble, { ...rest }] = useMutation<BrokerReadTransactionThread, BrokerReadTransactionThreadVariables>(brokerReadTransactionThread, {
        refetchQueries: ["GetOfferPublishedParticipants", "Offer"],
        variables
    })
    return {
        updateBubble,
        ...rest
    }
}